@if (hasPasfoto()) {
	<img class="image {{ size() }}" [src]="pasfotoSrc()" alt="" />
} @else {
	<div class="image {{ size() }} default"></div>
}
